import TimezoneSelect from 'components/timezone-select';
import * as strings from 'helpers/strings';
import { DateTime } from 'luxon';
import { DI } from 'modules';
import LiveInfoItem from 'pages/content/components/info-item';
import React, { Fragment } from 'react';
import BookEvent from './book-event';
import FollowEvent from './follow-event';
import LiveAudio from './live-audio';
import LiveLogin from './live-login';
import LiveRestrictions from './live-restrictions';
import LiveTargets from './live-targets';
import HotBox from 'components/hot-box/hot-box';

const disabledStatuses = ['finished', 'terminated', 'aborted'];

function LiveStreamInfo(props) {
  const stringsCommon = props.common.strings;
  const liveEvent = props.liveEvent;
  const disabled = disabledStatuses.includes(liveEvent.status);

  const startAt = DateTime.fromISO(liveEvent.start_at);
  const isSignedIn = props.user.isSignedIn;
  const { selectedLanguageID } = props;
  const selectedLanguage = liveEvent.languages.find(
    item => item.id === selectedLanguageID,
  );

  const liveOrNext = liveEvent.status === 'live' || liveEvent.status === 'next';

  const restreamTo = [
    liveEvent.streamTo.enabledFacebook && 'Facebook',
    liveEvent.streamTo.enabledYouTube && 'YouTube',
    liveEvent.streamTo.enabledPeriscope && 'Periscope',
    liveEvent.streamTo.enabledRTMP720 && 'RTMP 720p',
    liveEvent.streamTo.enabledRTMP1080 && 'RTMP 1080p',
    liveEvent.streamTo.enabledTVU && 'TVU',
  ].filter(Boolean);

  function string(key) {
    return props.common.strings[`page.lives.view.${key}`];
  }

  const startTimeAt = liveEvent.start_at_not_finalized
    ? props.common.strings['time_to_be_confirmed']
    : startAt.toFormat('H:mm');

  return (
    <Fragment>
      <div className="live-block">
        <div className="live-subblock">
          <div className="live-date">
            <LiveDateColumn
              label={string('date_of_start')}
              value={startAt.toFormat('LLLL dd, yyyy')}
            />
            <LiveDateColumn
              label={string('time_of_start')}
              value={startTimeAt}
            />
            <LiveDateColumn
              label={string('show_time_as')}
              value={<TimezoneSelect defTimezone/>}
            />
          </div>
        </div>
        {!isSignedIn && disabled ? (
          <div className="live-subblock">{string('finished')}</div>
        ) : (
          <Fragment>
            <LiveRestrictions text={liveEvent.restrictions}/>
            <div className="live-subblock">
              <LiveAudio
                disabled={disabled}
                liveEvent={liveEvent}
                selectedLanguageID={selectedLanguageID}
                onSelectLanguage={props.onSelectLanguage}
              />
              {disabled ? (
                <div className="live-subblock">{string('finished')}</div>
              ) : isSignedIn ? (
                liveOrNext ? (
                  selectedLanguage && selectedLanguage.booked ? (
                    <Fragment>
                      <LiveTargets
                        liveEvent={liveEvent}
                        selectedLanguageID={selectedLanguageID}
                      />
                    </Fragment>
                  ) : (
                    <BookEvent
                      liveEvent={liveEvent}
                      selectedLanguageID={selectedLanguageID}
                    />
                  )
                ) : (
                  <FollowEvent liveEvent={liveEvent}/>
                )
              ) : (
                <LiveLogin liveOrNext={liveOrNext}/>
              )}
            </div>
          </Fragment>
        )}
      </div>
      {liveEvent.description && (
        <div className="live-description-mobile">
          <span className="live-description-mobile__title">
            {string('description')}
          </span>
          <div className="live-description-mobile-text">
            <p>{liveEvent.description}</p>
          </div>
        </div>
      )}

      <HotBox
        clsName={'hot-box--column'}
        title={stringsCommon['page.video.hotbox.title']}
        text={stringsCommon['page.video.hotbox.text']}
        buttonName={stringsCommon['page.video.hotbox.button']}
      />

      {(!disabled || isSignedIn) && (
        <div className="live-block">
          <span className="live-info__title">{string('stream_info')}</span>
          <div className="live-info-list">
            <LiveInfoItem
              label={string('restream_to')}
              value={restreamTo.join(', ')}
            />
            <LiveInfoItem
              label={string('format')}
              value={`live, ${liveEvent.format}`}
            />
            <LiveInfoItem
              label={string('quality')}
              value={`${strings.humanize(liveEvent.quality)} ${string(
                'quality',
              ).toLowerCase()}`}
            />
          </div>
        </div>
      )}
    </Fragment>
  );
}

function LiveDateColumn(props) {
  return (
    <div className="live-date-column">
      <span className="live-date__label">{props.label}</span>
      <span className="live-date__value">{props.value}</span>
    </div>
  );
}

export default DI(['user', 'common'])(LiveStreamInfo);
